import React, { useState } from 'react';
import ChevronLeft from '@uber/base-icons/chevron-left';
import ChevronRight from '@uber/base-icons/chevron-right';
import { styled } from 'baseui';
import { Button, SHAPE, SIZE } from 'baseui/button';
const CollapsiblePanelContainer = styled<'div', {
  $isCollapsed: boolean;
}>('div', ({
  $theme,
  $isCollapsed
}) => ({
  [$theme.mediaQuery.medium]: {
    paddingTop: $theme.sizing.scale200
  },
  position: 'relative',
  width: $isCollapsed ? '30px' : '100%',
  height: '100%',
  overflow: 'hidden',
  transition: `width ${$theme.animation.timing300}`
}));
const StyledToggleButton = styled(Button, ({
  $theme
}) => ({
  position: 'absolute',
  color: $theme.colors.backgroundPrimary,
  visibility: 'hidden',
  zIndex: 2,
  [$theme.mediaQuery.medium]: {
    visibility: 'visible',
    top: '0',
    left: `-${$theme.sizing.scale100}`,
    right: `-${$theme.sizing.scale400}`
  }
}));
type PropsT = {
  children: React.ReactNode;
  onCollapseChange: (isPanelCollapsed: boolean) => void;
  className?: string;
};
export const CollapsibleSidePanel = ({
  children,
  onCollapseChange,
  className = ''
}: PropsT) => {
  const [isPanelCollapsed, setIsPanelCollapsed] = useState(false);
  const togglePanel = () => {
    setIsPanelCollapsed(prev => {
      const newState = !prev;
      onCollapseChange(newState);
      return newState;
    });
  };
  return <CollapsiblePanelContainer $isCollapsed={isPanelCollapsed} className={className}>
      <StyledToggleButton size={SIZE.mini} shape={SHAPE.square} onClick={togglePanel} data-testid="toggle-button">
        {isPanelCollapsed ? <ChevronLeft title="Left" /> : <ChevronRight title="Right" />}
      </StyledToggleButton>
      {!isPanelCollapsed && children}
    </CollapsiblePanelContainer>;
};